import React from "react";

import "./BodySection.css";

const BodySection = ({ title, header, text }) => {
  return (
    <>
      <div className="content-about">
        {/* Title of the box, on the left side */}
        <div className="title-about">
          <h4>{title}</h4>
        </div>

        {/* Body of the box, on the right side */}
        <div className="body-about">
          <h3>
            <strong>{header}</strong>
          </h3>
          <p>{text}</p>
        </div>
      </div>
    </>
  );
};

export default BodySection;
